var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImportIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.36752 1C9.70803 1 10.0361 1.11654 10.2951 1.32684L10.3889 1.41005L13.5769 4.5C13.8177 4.73338 13.9647 5.04067 13.9944 5.36685L14 5.48995V13.6C14 14.3381 13.4108 14.9427 12.6634 14.9962L12.5556 15H8.22222V13.6H12.5556V6.6H9.30556C8.74246 6.6 8.27968 6.18358 8.22718 5.65112L8.22222 5.55V2.4H3.88889V8H2.44444V2.4C2.44444 1.66195 3.03369 1.05728 3.78109 1.00384L3.88889 1H9.36752ZM5.12176 9.72515L7.16453 11.705C7.44656 11.9784 7.44656 12.4216 7.16453 12.695L5.12176 14.6748C4.83971 14.9483 4.38243 14.9483 4.10038 14.6748C3.81834 14.4015 3.81834 13.9583 4.10038 13.6849L4.91023 12.9H1.72222C1.32335 12.9 1 12.5866 1 12.2C1 11.8134 1.32335 11.5 1.72222 11.5H4.91023L4.10038 10.7151C3.81834 10.4417 3.81834 9.9985 4.10038 9.72515C4.38243 9.45173 4.83971 9.45173 5.12176 9.72515ZM9.66667 2.68995V5.2H12.2564L9.66667 2.68995Z",
    fill: "#4F46E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIc);
export default __webpack_public_path__ + "static/media/import_ic.da1680e0de1bc18cf0b8421ff20e3eb7.svg";
export { ForwardRef as ReactComponent };